import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    IFileUploadTicketAction,
    IFileUploadTicketSuccessAction,
    IFileUploadTicketErrorAction
} from '../actions/file-upload';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type FileUploadTicketAction
    = IFileUploadTicketAction
    | IFileUploadTicketSuccessAction
    | IFileUploadTicketErrorAction;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const init = (state: ITicketsState, action: FileUploadTicketAction) => ({
    ...state,
    fileUploads: initialState.fileUploads
});

const success = (state: ITicketsState, action: FileUploadTicketAction) => ({
    ...state,
    fileUploads: {
        data: (action as IFileUploadTicketSuccessAction).data,
        status: action.status
    }
});

const failure = (state: ITicketsState, action: FileUploadTicketAction) => ({
    ...state,
    fileUploads: {
        status: action.status,
        error: (action as IFileUploadTicketErrorAction).error
    }
});

const reset = (state: ITicketsState, action: FileUploadTicketAction) => ({
    ...state,
    fileUploads: {
        status: action.status,
    }
});
export const fileUploadTicketReducer = createAsyncReducer(initialState, init, success, failure, reset);
